<template>
  <div ref="sliderElement" class="slider-wrap">
    <figure v-if="chat.message_rich.message" class="msg tripla" role="group">
      <p>{{ chat.message_rich.message }}</p>
      <figure-caption :chat="chat" :operator-name="operatorName" />
    </figure>
    <div class="slider-wrap" :class="{ 'manual-slider': manualSliderMode }">
      <div ref="theSlider" class="slider">
        <div ref="spacer" class="spacer-small"></div>
        <brr-slider
          v-for="(slide, index) in displaySortedSlides"
          :key="index"
          ref="slides"
          :slide="slide"
          :chat="chat"
        />
        <div class="spacer-small"></div>
      </div>
      <button v-if="slideCount > 1" class="arrow arrow--left" @click="move('<')"></button>
      <button v-if="slideCount > 1" class="arrow arrow--right" @click="move('>')"></button>
    </div>
  </div>
</template>

<script>
import sliderMixin from './mixins/sliderMixin'
import BrrSlider from 'UtilityComponents/BrrSlider.vue'
import { formatPrice } from 'Utilities'

export default {
  components: {
    BrrSlider
  },
  mixins: [sliderMixin],
  computed: {
    displaySortedSlides() {
      return this.chat.message_rich.slides.sort(function (a, b) {
        return formatPrice(a.price) - formatPrice(b.price)
      })
    },
    slideCount() {
      return this.chat.message_rich.slides.length
    }
  }
}
</script>
